// var Metajelo = require("../output/Metajelo"); // For bower

import * as Metajelo from  "./index.opt.js";
window.Metajelo = Metajelo;
